import { useMediaQuery, useTheme } from '@material-ui/core'
import * as React from 'react'
import {
  DateField,
  Filter,
  TextField,
  TextInput,
  useTranslate,
  Pagination,
  Datagrid,
  Identifier,
} from 'react-admin'
import { ResourceName } from '../../../core/ResourceName'
import List from '../../common/customized-ra-components/List'
import FilterProps from '../../common/FilterProps'

const ListTitle = () => {
  const t = useTranslate()
  return (
    <span>
      {t(`resources.${ResourceName.STATS_OVERALL_VIEW_LIST}.titles.list`)}
    </span>
  )
}

const OverallViewFilters = (props: FilterProps) => (
  <Filter {...props}>
    <TextInput source="name" alwaysOn autoFocus />
  </Filter>
)

export const OverallViewList = ({ ...props }) => {
  const theme = useTheme()
  const xSmallScreen = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <List
      {...props}
      actions={false}
      filter={{
        hasObjects: true,
      }}
      filters={<OverallViewFilters />}
      sort={{ field: 'id', order: 'DESC' }}
      title={<ListTitle />}
      pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
      bulkActionButtons={false}
    >
      <Datagrid
        rowClick={(id: Identifier) =>
          `${ResourceName.STATS_OVERALL_VIEW}?${new URLSearchParams({
            filter: `{"id":"${id}"}`,
          })}`
        }
        hasBulkActions={false}
      >
        <TextField source="id" />
        <TextField source="name" />
        <DateField source="dateStart" showTime />
        {!xSmallScreen && <DateField source="dateEnd" showTime />}
      </Datagrid>
    </List>
  )
}
